module.exports = __webpack_public_path__ + "img/block-portfolio.89deb394.svg";